export default __webpack_public_path__ + "static/gifgroup-b9bb6c74956736bc1ec849ac243f9f49.gif";